import { Box } from '@mui/material'
import { PISectionInput, PISectionValidation } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingsPageStyles'
import { CustomHTMLSelect } from 'src/consumer/components/helperComponents'
import { FORM_CONSTANTS, GRID_CONFIG } from '../utils/patientFormConfig'
import { usePatientFormI18n } from '../utils/patientFormI18n'
import {
  PatientFieldHelperText,
  PatientFieldLabel,
  PatientFormGridItem,
} from './FormField'

const INPUT_BASE_STYLE = {
  width: '100%',
  minHeight: '40px',
  boxSizing: 'border-box',
  fontSize: '14px',
}

function preventInvalidAgeKeyDown(event) {
  if (
    event.key === '.' ||
    event.key === ',' ||
    event.key === '-' ||
    event.key === '+' ||
    event.key === 'e' ||
    event.key === 'E'
  ) {
    event.preventDefault()
  }
}

export default function PatientAgeField({
  patientDetails,
  editMode = true,
  formHook,
  validationHook,
}) {
  const { copy } = usePatientFormI18n()
  const ageValidation = validationHook.getFieldValidation('age')

  return (
    <PatientFormGridItem gridConfig={GRID_CONFIG}>
      <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', minWidth: 0 }}>
        <PatientFieldLabel required>{copy.ageLabel}</PatientFieldLabel>
        <Box
          sx={{
            display: 'grid',
            gap: 1.25,
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'minmax(0, 1fr) minmax(0, 1fr) minmax(132px, 0.85fr)',
            },
            alignItems: 'end',
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <PatientFieldLabel style={{ marginBottom: '4px', fontSize: '12px' }}>
              {copy.ageYearsLabel}
            </PatientFieldLabel>
            <PISectionInput
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={patientDetails?.ageYears ?? patientDetails?.age ?? ''}
              onChange={formHook.handleAgeChange}
              onKeyDown={preventInvalidAgeKeyDown}
              disabled={!editMode}
              placeholder="0"
              style={INPUT_BASE_STYLE}
            />
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <PatientFieldLabel style={{ marginBottom: '4px', fontSize: '12px' }}>
              {copy.ageSecondaryValueLabel}
            </PatientFieldLabel>
            <PISectionInput
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={patientDetails?.ageSecondaryValue ?? ''}
              onChange={formHook.handleAgeSecondaryValueChange}
              onKeyDown={preventInvalidAgeKeyDown}
              disabled={!editMode}
              placeholder={copy.ageSecondaryValuePlaceholder}
              style={INPUT_BASE_STYLE}
            />
          </Box>

          <Box sx={{ minWidth: 0 }}>
            <PatientFieldLabel style={{ marginBottom: '4px', fontSize: '12px' }}>
              {copy.ageSecondaryUnitLabel}
            </PatientFieldLabel>
            <CustomHTMLSelect
              value={
                patientDetails?.ageSecondaryUnit || FORM_CONSTANTS.DEFAULT_AGE_SECONDARY_UNIT
              }
              onChange={formHook.handleAgeSecondaryUnitChange}
              disabled={!editMode}
              getOptionLabel={(option) => option?.label}
              getOptionValue={(option) => option?.value}
              options={[
                {
                  value: FORM_CONSTANTS.AGE_SECONDARY_UNIT_MONTHS,
                  label: copy.ageUnitMonths,
                },
                {
                  value: FORM_CONSTANTS.AGE_SECONDARY_UNIT_DAYS,
                  label: copy.ageUnitDays,
                },
              ]}
              outerMostDivStyle={{ width: '100%', gap: 0 }}
            />
          </Box>
        </Box>
        <PatientFieldHelperText>{copy.ageHelper}</PatientFieldHelperText>
        {ageValidation.showError && <PISectionValidation>{ageValidation.errorMessage}</PISectionValidation>}
      </Box>
    </PatientFormGridItem>
  )
}
